// import types
import {
  RoundedNumericValueField,
  RoundedNumericValueRow
} from './useGetColumns.types';

// import utils
import { roundTo2 } from '../components/EndOfEmploymentSettlementsForm.utils';

export const getRoundedNumericValue =
  (fieldName: RoundedNumericValueField, showPlusMinusHoursReversed = false) =>
  (_: unknown, row: RoundedNumericValueRow) => {
    const value = row?.[fieldName];
    if (typeof value !== 'number' || value === 0) return '';

    const rounded = roundTo2(value);
    if (!showPlusMinusHoursReversed) return rounded;

    return value > 0 ? `-${rounded}` : `+${Math.abs(rounded)}`;
  };
